import React from 'react';

// Shared live score readout shown during play across every game.
// Pass extra {label, value} pairs via `stats` for game-specific counters
// (e.g. MemoryGame's move count).
function ScoreBadge({ score, stats = [] }) {
  return (
    <div className="score-card">
      <span>اسکور: {score}</span>
      {stats.map(({ label, value }) => (
        <span key={label}>{label}: {value}</span>
      ))}
    </div>
  );
}

export default ScoreBadge;
